import { Box, Button as ThemeUIButton } from "theme-ui";

import * as styles from "./SingularOptions.styles";

export default function SingularOptions({
  baseImage,
  overlayedImage,
  options,
  value: selectedValue,
  onChange,
}) {
  const selectedOption = options.find(
    (option) => option.value === selectedValue
  );

  return (
    <Box sx={styles.singularProfileContainer}>
      <Box sx={styles.images}>
        <Box
          sx={styles.baseImage({
            baseImage,
          })}
        />
        <Box
          sx={styles.overlayedImage({
            overlayedImage,
            overlayedImageWidth: selectedOption?.overlayedImageWidth,
          })}
        />
      </Box>
      <Box sx={styles.optionsContainer}>
        {options.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <ThemeUIButton
              key={option.value}
              type="button"
              sx={styles.option({ isSelected })}
              variant="text.copy1"
              onClick={() => {
                onChange(option.value);
              }}
            >
              {option.label}
            </ThemeUIButton>
          );
        })}
      </Box>
    </Box>
  );
}
